import React, { useState } from "react";
import "./ChinaTourDetails.scss";
import { useLocation } from "react-router-dom";
import Topbar from "../../components/TopbarChina/Topbar";
import { FaPlus } from "react-icons/fa6";
import { Accordion, AccordionItem } from "react-light-accordion";
import "react-light-accordion/demo/css/index.css";
import { Interweave } from 'interweave';
import { IoChevronBack } from "react-icons/io5";
import { Link } from 'react-router-dom'
import Footer from "../../components/Footer/Footer";

function ChinaTourDetails() {
  const location = useLocation();
  const { tour } = location.state;
  // <Interweave content="This string contains <b>HTML</b> and will safely be rendered!" />;

  return (
    <div className="tour-details-box">
      <Link to='/tours'><IoChevronBack  className="back"/></Link>
      
      
      <Topbar bgColor={true} />
      <h1>{tour.tour_title}</h1>
      <div className="tour-desc-box">
      
        {tour.days.map((day, index) => (
          <div className="day" key={index}>
            <h2>День {index + 1}</h2>
            <div className="short-desc">
              <ul>
                {day.short_description.map((el) => (
                  <li key={el}>{<Interweave content={el} />}</li>
                ))}
              </ul>
            </div>

            <div>
              <Accordion atomic={false}>
                <AccordionItem  title="Детали">
                  <p style={{ padding: "16px" }}><Interweave content={day.detailed_description} /></p>
                </AccordionItem>
              </Accordion>
            </div>
          </div>
        ))}
      </div>
      <Footer/>
    </div>
  );
}

export default ChinaTourDetails;
